var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.9999H4C3.46957 14.9999 2.96086 14.7892 2.58579 14.4141C2.21071 14.039 2 13.5303 2 12.9999V3.99988C2 3.46944 2.21071 2.96074 2.58579 2.58566C2.96086 2.21059 3.46957 1.99988 4 1.99988H13C13.5304 1.99988 14.0391 2.21059 14.4142 2.58566C14.7893 2.96074 15 3.46944 15 3.99988V4.99988M11 8.99988H20C21.1046 8.99988 22 9.89531 22 10.9999V19.9999C22 21.1044 21.1046 21.9999 20 21.9999H11C9.89543 21.9999 9 21.1044 9 19.9999V10.9999C9 9.89531 9.89543 8.99988 11 8.99988Z",
    stroke: "#D52B2B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyicon);
export default __webpack_public_path__ + "static/media/copyicon.605c3704ece342648b48b9092020f21f.svg";
export { ForwardRef as ReactComponent };